import { render } from "./SideOverlaySlot.vue?vue&type=template&id=4d3ea5bb&scoped=true&lang=pug"
import script from "./SideOverlaySlot.vue?vue&type=script&lang=js"
export * from "./SideOverlaySlot.vue?vue&type=script&lang=js"

import "./SideOverlaySlot.vue?vue&type=style&index=0&id=4d3ea5bb&scoped=true&lang=scss"
import "./SideOverlaySlot.vue?vue&type=style&index=1&id=4d3ea5bb&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3ea5bb"]])

export default __exports__